module.exports = __webpack_public_path__ + "static/media/coupon_checkmark.0db7ee5e.svg";